module.exports = __webpack_public_path__ + "static/media/cafe24-ali.33a1661b.png";